var _excluded = ["eleType", "to", "reportType", "reportData", "onClick", "children", "disabled", "className", "primary", "icon", "target", "rel"],
  _excluded2 = ["trigger", "className", "onCancel", "visible", "destroyInnerWhenHidden", "children", "okButtonProps", "cancelButtonProps", "closable"],
  _excluded3 = ["className", "icon"],
  _excluded4 = ["className", "icon", "onOk", "onCancel"],
  _excluded5 = ["className", "children", "active", "type", "blocked", "size", "target", "style"],
  _excluded6 = ["icon", "className", "size", "style", "color"],
  _excluded7 = ["children", "overlayClassName"],
  _excluded8 = ["children", "className", "gutter", "grid"],
  _excluded9 = ["icon", "children", "addon", "className", "showIconMore", "blockClassName", "innerClassName", "addonClassName", "elementType", "onClick"],
  _excluded10 = ["className", "onClick", "elementType", "noHover"],
  _excluded11 = ["className", "type"],
  _excluded12 = ["className"],
  _excluded13 = ["className", "children"],
  _excluded14 = ["className"],
  _excluded15 = ["className", "type", "size", "squared"],
  _excluded16 = ["href", "target", "onClick"],
  _excluded17 = ["className", "children", "dropdownClassName", "fullWidth", "size", "style", "suffixIcon", "onBlur", "onFocus", "showSearch"],
  _excluded18 = ["className", "dotTheme", "dots"],
  _excluded19 = ["className", "mode"],
  _excluded20 = ["className", "spin", "size"],
  _excluded21 = ["type", "children", "className", "spinning", "size", "loadingClassName"],
  _excluded22 = ["iconProps", "className", "style", "children", "maskTransparent", "wrapperClassName", "tip"],
  _excluded23 = ["size"],
  _excluded24 = ["className", "loading"],
  _excluded25 = ["className"],
  _excluded26 = ["className"],
  _excluded27 = ["className"],
  _excluded28 = ["className", "type"],
  _excluded29 = ["className"],
  _excluded30 = ["className", "error"],
  _excluded31 = ["inputType", "value", "wrapperClassName", "className", "onFocus", "onBlur", "onChange", "placeholder", "error"],
  _excluded32 = ["className"],
  _excluded33 = ["className"],
  _excluded34 = ["children", "className", "name", "validateStatus", "labelHidden"],
  _excluded35 = ["className"],
  _excluded36 = ["className"],
  _excluded37 = ["className", "menus", "title", "mode"],
  _excluded38 = ["className"],
  _excluded39 = ["className", "children"],
  _excluded40 = ["overlayClassName"],
  _excluded41 = ["className"],
  _excluded42 = ["className"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Alert, Button, Carousel, Checkbox, Col, Dropdown, Form, Input, Menu, Modal, Popover, Progress, Radio, Row, Select, Spin, Steps, Switch, Table, Tabs, Tooltip, Typography } from "antd";
import Tag from "antd/es/tag";
import SubMenu from "antd/lib/menu/SubMenu";
import csn from "classnames";
import React, { Children, cloneElement, createContext, createElement, forwardRef, isValidElement, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useToggle } from "../../hooks";
import { tradingConfig } from "../../utils/config";
import { PionexReportV2 } from "../../utils/report";
// import { IConNames } from "../../less/iconfont/iconfont";
import cs from "./cs.m.less";

/**
 * -------------------------------------------------------------------------
 * @组件维护注意事项
 * 1. 新的组件请在组件代码末尾新增，严禁在中间任意位置插入编写新的组件功能；
 * 2. 定制化行为组件，请赋予一定的组件中注释进行说明，便于使用者理解。
 * 3. 该文件维护的组件基本都是基于Antd组件的封装，且无破坏性重构的，如涉及强功能定制化组件，请新开组件文件进行管理。
 * 4. 组件样式遵循涉及组件化统一规范，请勿涵盖业务定制样式「外部自行管理定制化样式」。
 * 5. 组件使用全局样式名称，以【t-*】前缀命名而来，可在其他业务组件中结合 css-module 的 :global 关键字进行样式覆盖。
 * -------------------------------------------------------------------------
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var appPathReg = /^(?:\w+?\:)/;
/**
 * 行为上报组件
 */
export default function TReportLink(_ref) {
  var eleType = _ref.eleType,
    to = _ref.to,
    reportType = _ref.reportType,
    reportData = _ref.reportData,
    onClick = _ref.onClick,
    children = _ref.children,
    disabled = _ref.disabled,
    className = _ref.className,
    primary = _ref.primary,
    icon = _ref.icon,
    target = _ref.target,
    rel = _ref.rel,
    props = _objectWithoutProperties(_ref, _excluded);
  var isValidPath = !!to && _typeof(to) === "object" || typeof to === "string" && !appPathReg.test(to);
  var hasReport = !!reportType && sessionStorage.getItem("--show-ga-report-tip--") === "show";
  // 为了安全性，新开窗口打开的链接，都需要加上这个字段
  rel = target === "_blank" ? "noreferrer" : rel;
  return /*#__PURE__*/createElement(eleType ? eleType : isValidPath ? Link : "a", _objectSpread(_objectSpread(_objectSpread({
    target: target,
    rel: rel
  }, props), isValidPath ? {
    to: to
  } : {
    href: to
  }), {}, {
    className: csn("t-report-link", disabled && "disabled", className, cs.tReportLink, hasReport && cs.tHasRep, primary && cs.primary),
    onClick: useCallback(function (e) {
      if (disabled) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      reportType && reportType in PionexReportV2 && PionexReportV2[reportType](reportData);
      onClick && onClick(e);
    }, [disabled, reportType, reportData, onClick])
  }), icon ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Iconfont, {
      icon: icon
    }), children]
  }) : children);
}
var ForTModal = /*#__PURE__*/forwardRef(
/**
 * destroyInnerWhenHidden 用于标记是否在模态框隐藏时，销毁children的渲染。
 * @param props
 * @param ref
 */
function (_ref2, ref) {
  var trigger = _ref2.trigger,
    className = _ref2.className,
    onCancel = _ref2.onCancel,
    visible = _ref2.visible,
    destroyInnerWhenHidden = _ref2.destroyInnerWhenHidden,
    children = _ref2.children,
    _ref2$okButtonProps = _ref2.okButtonProps,
    okButtonProps = _ref2$okButtonProps === void 0 ? {} : _ref2$okButtonProps,
    _ref2$cancelButtonPro = _ref2.cancelButtonProps,
    cancelButtonProps = _ref2$cancelButtonPro === void 0 ? {} : _ref2$cancelButtonPro,
    _ref2$closable = _ref2.closable,
    closable = _ref2$closable === void 0 ? false : _ref2$closable,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var _useToggle = useToggle(),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    _visible = _useToggle2[0],
    _useToggle2$ = _useToggle2[1],
    toggle = _useToggle2$.toggle,
    setFalse = _useToggle2$.setFalse,
    setTrue = _useToggle2$.setTrue;
  var _useToggle3 = useToggle(),
    _useToggle4 = _slicedToArray(_useToggle3, 2),
    destroyed = _useToggle4[0],
    toggleDestroy = _useToggle4[1].toggle;
  var mVisible = typeof visible === "boolean" ? visible : _visible;
  useEffect(function () {
    if (destroyInnerWhenHidden) {
      if (mVisible) {
        toggleDestroy(false);
      } // 避免缓动隐退时突兀空白。
      else {
        setTimeout(function () {
          toggleDestroy(true);
        }, 200);
      }
    }
  }, [destroyInnerWhenHidden, mVisible, toggleDestroy]);
  useImperativeHandle(ref, function () {
    return {
      toggle: toggle,
      open: setTrue,
      close: setFalse
    };
  }, [setFalse, setTrue, toggle]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [trigger ? /*#__PURE__*/cloneElement(trigger, {
      onClick: function onClick() {
        var _ref3 = trigger.props,
          onClick = _ref3.onClick;
        onClick && onClick();
        toggle();
      }
    }) : null, /*#__PURE__*/_jsx(Modal, _objectSpread({
      visible: mVisible,
      onCancel: onCancel || setFalse,
      className: csn("t-modal", className, cs.tModal),
      closeIcon: /*#__PURE__*/_jsx(Iconfont, {
        icon: "icon_close_normal",
        className: cs.tModalClose
      }),
      closable: closable,
      children: destroyed ? null : children,
      okButtonProps: calcTBtnStaticProps(_objectSpread({
        type: "primary"
      }, okButtonProps)),
      cancelButtonProps: calcTBtnStaticProps(_objectSpread({
        type: "bordered"
      }, cancelButtonProps))
    }, props))]
  });
});
function modifyModalProps(_ref4, noIcon) {
  var className = _ref4.className,
    icon = _ref4.icon,
    props = _objectWithoutProperties(_ref4, _excluded3);
  return _objectSpread({
    className: csn("t-modal", className, cs.tModal),
    icon: noIcon ? null : icon
  }, props);
}
export var TModal = ForTModal;
// 转换为Promise，试用与确认的场景
TModal.promisify = {};
["confirm", "error", "info", "success", "warn", "warning"].map(function (type) {
  // 加入自定义样式
  TModal[type] = function (props) {
    return Modal[type](modifyModalProps(props));
  };

  // 若使用promisify的快速函数，将不能再使用返回的update和destroy操作方法。
  TModal.promisify[type] = function (_ref5) {
    var className = _ref5.className,
      icon = _ref5.icon,
      _onOk = _ref5.onOk,
      _onCancel = _ref5.onCancel,
      props = _objectWithoutProperties(_ref5, _excluded4);
    return new Promise(function (res, rej) {
      Modal[type](modifyModalProps(_objectSpread({
        onOk: function onOk() {
          for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
            arg[_key] = arguments[_key];
          }
          return res((_onOk === null || _onOk === void 0 ? void 0 : _onOk(arg)) || arg);
        },
        onCancel: function onCancel() {
          for (var _len2 = arguments.length, arg = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            arg[_key2] = arguments[_key2];
          }
          _onCancel === null || _onCancel === void 0 || _onCancel(arg);
          return rej();
        }
      }, props)));
    });
  };
});
TModal.destroyAll = Modal.destroyAll;
export function useModalStatic(typeOrProps) {
  var _props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isFirstP = typeof typeOrProps !== "string";
  var type = isFirstP ? "confirm" : typeOrProps;
  var mProps = isFirstP ? typeOrProps : _props;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var ins = useRef();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var mp = useRef(mProps);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(function () {
    var _ins$current;
    // TODO:自定义props浅层比对，自动更新弹窗的props，现在的对比算法还存在问题；
    // const npk = Object.keys(mProps);
    // const nl = npk.length;
    // const ol = Object.keys(mp.current).length;
    // if (nl !== ol || npk.some((k) => mProps[k] !== mp.current[k])) {
    // }
    (_ins$current = ins.current) === null || _ins$current === void 0 || _ins$current.update(modifyModalProps(mProps, isFirstP));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mProps, isFirstP]);
  mp.current = mProps;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(function () {
    // 销毁组件
    return function () {
      var _ins$current2;
      return (_ins$current2 = ins.current) === null || _ins$current2 === void 0 ? void 0 : _ins$current2.destroy();
    };
  }, []);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var openModal = useCallback(function () {
    ins.current = TModal[type](mp.current);
  }, [type]);
  return openModal;
}

// 支持自动销毁、更新props
TModal.useStatic = useModalStatic;

/**
 * 块级交互连接
 */
export function TReportBlockLink(_ref6) {
  var className = _ref6.className,
    children = _ref6.children,
    active = _ref6.active,
    _ref6$type = _ref6.type,
    type = _ref6$type === void 0 ? "default" : _ref6$type,
    blocked = _ref6.blocked,
    size = _ref6.size,
    target = _ref6.target,
    _ref6$style = _ref6.style,
    style = _ref6$style === void 0 ? {} : _ref6$style,
    props = _objectWithoutProperties(_ref6, _excluded5);
  return /*#__PURE__*/_jsx(TReportLink, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, props), target === "_blank" ? {
    rel: "noreferrer"
  } : {})), {}, {
    target: target,
    style: _objectSpread(_objectSpread({}, style), size ? {
      height: "".concat(size, "px"),
      lineHeight: "".concat(size, "px"),
      borderRadius: "".concat(size / 2, "px")
    } : {}),
    className: csn("t-report-block-link", className, cs.tBlockLink, cs["type_".concat(type)], blocked && cs.blocked, _defineProperty({}, cs.active, active)),
    children: children
  }));
}

/**
 * 自定义主题图标访问组件
 */
export function Iconfont(_ref7) {
  var icon = _ref7.icon,
    className = _ref7.className,
    size = _ref7.size,
    _ref7$style = _ref7.style,
    style = _ref7$style === void 0 ? {} : _ref7$style,
    color = _ref7.color,
    props = _objectWithoutProperties(_ref7, _excluded6);
  return /*#__PURE__*/_jsx("span", _objectSpread({
    className: csn("iconfont", "icon-".concat(icon), className),
    style: _objectSpread({
      fontSize: size,
      color: color
    }, style)
  }, props));
}

/**
 * 块级下拉组件
 */
export function TDropdownBlock(_ref8) {
  var children = _ref8.children,
    overlayClassName = _ref8.overlayClassName,
    props = _objectWithoutProperties(_ref8, _excluded7);
  return /*#__PURE__*/_jsx(Dropdown, _objectSpread(_objectSpread({
    overlayClassName: csn(overlayClassName, cs.tDropBlockOverlay)
  }, props), {}, {
    children: children
  }));
}

/**
 * 块级菜单组
 * @param param0
 */
export function TMenuBlockGroup(_ref9) {
  var children = _ref9.children,
    className = _ref9.className,
    _ref9$gutter = _ref9.gutter,
    gutter = _ref9$gutter === void 0 ? 12 : _ref9$gutter,
    grid = _ref9.grid,
    props = _objectWithoutProperties(_ref9, _excluded8);
  var childLen = Children.count(children);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    className: csn(cs.tMenuBlockGroup, className, "t-menu-block-group", _defineProperty({}, cs.tMBGGrid, grid && childLen > 1))
  }, props), {}, {
    children: grid && childLen > 1 ? /*#__PURE__*/_jsx(Row, {
      gutter: gutter,
      children: Children.map(children, function (child, idx) {
        var marginBottom = Math.ceil((idx + 1) / grid) < Math.ceil(childLen / grid) ? gutter : undefined;
        return /*#__PURE__*/_jsx(Col, {
          span: 24 / grid,
          style: {
            marginBottom: marginBottom
          },
          children: child
        });
      })
    }) : children
  }));
}
var _noop = function _noop() {
  return 0;
};
/**
 * 块级菜单单元
 * @param param0
 */
export function TMenuBlock(_ref10) {
  var icon = _ref10.icon,
    children = _ref10.children,
    addon = _ref10.addon,
    className = _ref10.className,
    _ref10$showIconMore = _ref10.showIconMore,
    showIconMore = _ref10$showIconMore === void 0 ? true : _ref10$showIconMore,
    blockClassName = _ref10.blockClassName,
    innerClassName = _ref10.innerClassName,
    addonClassName = _ref10.addonClassName,
    _ref10$elementType = _ref10.elementType,
    elementType = _ref10$elementType === void 0 ? TReportLink : _ref10$elementType,
    onClick = _ref10.onClick,
    props = _objectWithoutProperties(_ref10, _excluded9);
  return /*#__PURE__*/_jsxs(TBlock, _objectSpread(_objectSpread({
    onClick: onClick || _noop,
    elementType: elementType,
    className: csn("t-menu-block", className, cs.tMenuBlock)
  }, props), {}, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: csn(cs.tMenuBlockInner, blockClassName),
      children: [!icon ? false : typeof icon === "string" ? /*#__PURE__*/_jsx(Iconfont, {
        icon: icon
      }) : icon, /*#__PURE__*/_jsx("div", {
        className: csn(innerClassName),
        children: children
      }), showIconMore && /*#__PURE__*/_jsx(Iconfont, {
        icon: "icon_LearnMore_A2",
        className: cs.tMenuBlockMore
      })]
    }), addon && /*#__PURE__*/_jsx("div", {
      className: csn(cs.tMenuBlockAddon, addonClassName),
      children: addon
    })]
  }));
}

/**
 * 块组件
 */
export function TBlock(_ref11) {
  var className = _ref11.className,
    onClick = _ref11.onClick,
    _ref11$elementType = _ref11.elementType,
    elementType = _ref11$elementType === void 0 ? "div" : _ref11$elementType,
    noHover = _ref11.noHover,
    props = _objectWithoutProperties(_ref11, _excluded10);
  var _className = csn(cs.tBlock, _defineProperty({}, cs.link, !!onClick), className);
  return /*#__PURE__*/createElement(elementType, _objectSpread({
    className: csn("t-block", _className, noHover && "t-block-no-hover"),
    onClick: onClick
  }, props));
}
export function TMenu(_ref12) {
  var className = _ref12.className,
    _ref12$type = _ref12.type,
    type = _ref12$type === void 0 ? "default" : _ref12$type,
    props = _objectWithoutProperties(_ref12, _excluded11);
  return /*#__PURE__*/_jsx(Menu, _objectSpread({
    className: csn("t-menu", className, cs.tMenu, cs[type])
  }, props));
}
export function TSubMenu(_ref13) {
  var className = _ref13.className,
    props = _objectWithoutProperties(_ref13, _excluded12);
  return /*#__PURE__*/_jsx(SubMenu, _objectSpread({
    className: csn("t-submenu", cs.tSubMenu, className)
  }, props));
}
export function TMenuItem(_ref14) {
  var className = _ref14.className,
    children = _ref14.children,
    props = _objectWithoutProperties(_ref14, _excluded13);
  return /*#__PURE__*/_jsx(Menu.Item, _objectSpread(_objectSpread({
    className: csn("t-menu-item", className, cs.tMenuItem)
  }, props), {}, {
    children: children
  }));
}
export function TSwitch(_ref15) {
  var className = _ref15.className,
    props = _objectWithoutProperties(_ref15, _excluded14);
  return /*#__PURE__*/_jsx(Switch, _objectSpread(_objectSpread({}, props), {}, {
    className: csn(cs.tSwitch, className)
  }));
}
/**
 * 仅对镜头的配置字段进行计算修改，不允许在这里处理时间函数和复杂数据类型。
 * @param param0
 * @returns
 */
function calcTBtnStaticProps(_ref16) {
  var className = _ref16.className,
    type = _ref16.type,
    size = _ref16.size,
    squared = _ref16.squared,
    props = _objectWithoutProperties(_ref16, _excluded15);
  var typeClass;
  switch (type) {
    case "bordered":
    case "blue":
      typeClass = "t-button-".concat(type);
      break;
  }
  return _objectSpread({
    className: csn("t-button", className, size && cs[size], typeClass, squared && "t-btn-squared"),
    type: type === "bordered" ? undefined : type,
    size: size
  }, props);
}
export function TButton(_ref17) {
  var href = _ref17.href,
    target = _ref17.target,
    onClick = _ref17.onClick,
    props = _objectWithoutProperties(_ref17, _excluded16);
  return /*#__PURE__*/createElement(Button, _objectSpread(_objectSpread({
    onClick: useCallback(function (e) {
      if (href) {
        if (typeof href === "string" && !href.startsWith("/")) {} else {
          e.preventDefault();
          tradingConfig.history.push(href);
        }
      }
      return onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [href, onClick]),
    href: _typeof(href) === "object" ? href.pathname : href,
    target: target
  }, target === "_blank" ? {
    rel: "noreferrer"
  } : {}), calcTBtnStaticProps(props)));
}
TButton.Group = Button.Group;
export function TSelect(_ref18) {
  var className = _ref18.className,
    children = _ref18.children,
    dropdownClassName = _ref18.dropdownClassName,
    fullWidth = _ref18.fullWidth,
    size = _ref18.size,
    _ref18$style = _ref18.style,
    style = _ref18$style === void 0 ? {} : _ref18$style,
    _ref18$suffixIcon = _ref18.suffixIcon,
    suffixIcon = _ref18$suffixIcon === void 0 ? /*#__PURE__*/_jsx(Iconfont, {
      icon: "icon_More_down"
    }) : _ref18$suffixIcon,
    onBlur = _ref18.onBlur,
    onFocus = _ref18.onFocus,
    showSearch = _ref18.showSearch,
    props = _objectWithoutProperties(_ref18, _excluded17);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var _onBlur = useCallback(function (e) {
    setFocused(false);
    onBlur === null || onBlur === void 0 || onBlur(e);
  }, [onBlur]);
  var _onFocus = useCallback(function (e) {
    setFocused(true);
    onFocus === null || onFocus === void 0 || onFocus(e);
  }, [onFocus]);
  return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({
    className: csn("t-select", className, size && "size-".concat(size)),
    dropdownClassName: csn(dropdownClassName, "t-select-drop", size && "size-".concat(size)),
    style: _objectSpread(_objectSpread({}, style), fullWidth ? {
      width: "100%"
    } : {}),
    size: size,
    suffixIcon: focused && showSearch ? /*#__PURE__*/_jsx(Iconfont, {
      icon: "icon_search"
    }) : suffixIcon,
    menuItemSelectedIcon: /*#__PURE__*/_jsx(Iconfont, {
      icon: "icon_checked"
    }),
    onBlur: _onBlur,
    onFocus: _onFocus,
    showSearch: showSearch
  }, props), {}, {
    children: children
  }));
}
TSelect.Option = Select.Option;
export function TCarousel(_ref19) {
  var className = _ref19.className,
    _ref19$dotTheme = _ref19.dotTheme,
    dotTheme = _ref19$dotTheme === void 0 ? "dark" : _ref19$dotTheme,
    _ref19$dots = _ref19.dots,
    dots = _ref19$dots === void 0 ? true : _ref19$dots,
    props = _objectWithoutProperties(_ref19, _excluded18);
  return /*#__PURE__*/_jsx(Carousel, _objectSpread({
    className: csn("t-carousel", className, cs.tCarousel),
    dots: dots === false ? dots : {
      className: csn(cs.tCarouselDots, dots === null || dots === void 0 ? void 0 : dots.className, cs["dot_".concat(dotTheme)])
    }
  }, props));
}
export function TTabs(_ref20) {
  var className = _ref20.className,
    mode = _ref20.mode,
    props = _objectWithoutProperties(_ref20, _excluded19);
  return /*#__PURE__*/_jsx(Tabs, _objectSpread({
    className: csn("t-tabs", className, mode)
  }, props));
}
TTabs.TabPane = Tabs.TabPane;
export function TLoading(_ref21) {
  var className = _ref21.className,
    _ref21$spin = _ref21.spin,
    spin = _ref21$spin === void 0 ? true : _ref21$spin,
    size = _ref21.size,
    props = _objectWithoutProperties(_ref21, _excluded20);
  return /*#__PURE__*/_jsx("span", _objectSpread({
    className: csn("t-loading", spin && "anticon-spin", className, cs.tLoading, size)
  }, props));
}

/**
 * 单纯的蒙层loading，摒弃 TSpin的复杂嵌套结构。
 * @param param0
 * @returns
 */
export function TMaskLoading(_ref22) {
  var _ref22$type = _ref22.type,
    type = _ref22$type === void 0 ? "div" : _ref22$type,
    children = _ref22.children,
    className = _ref22.className,
    spinning = _ref22.spinning,
    size = _ref22.size,
    loadingClassName = _ref22.loadingClassName,
    props = _objectWithoutProperties(_ref22, _excluded21);
  return /*#__PURE__*/createElement(type, _objectSpread({
    className: csn("t-mask-loading", className)
  }, props), /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, /*#__PURE__*/_jsx("div", {
      className: csn("t-mask-loading-mask", spinning && "spinning"),
      children: /*#__PURE__*/_jsx(TLoading, {
        spin: spinning,
        size: size,
        className: loadingClassName
      })
    })]
  }));
}
export function TSpin(_ref23) {
  var _ref23$iconProps = _ref23.iconProps,
    iconProps = _ref23$iconProps === void 0 ? {} : _ref23$iconProps,
    className = _ref23.className,
    style = _ref23.style,
    children = _ref23.children,
    maskTransparent = _ref23.maskTransparent,
    wrapperClassName = _ref23.wrapperClassName,
    tip = _ref23.tip,
    props = _objectWithoutProperties(_ref23, _excluded22);
  // 根据icon的size，计算新的 icon 的居中边距调节值
  var size = iconProps.size,
    iconRestProps = _objectWithoutProperties(iconProps, _excluded23);
  var iconHalfSize = 20;
  switch (size) {
    case "small":
      iconHalfSize = 15;
      break;
    case "large":
      iconHalfSize = 34;
      break;
    default:
      iconHalfSize = 20;
      break;
  }
  return /*#__PURE__*/_jsx(Spin, _objectSpread({
    className: csn("t-spin", className)
    // 当没有包裹子节点时，默认去掉蒙层
    ,
    wrapperClassName: csn("t-spin-wrapper", wrapperClassName, (maskTransparent || !children) && "transparent"),
    indicator: /*#__PURE__*/_jsx(TLoading, _objectSpread({
      size: size,
      style: {
        marginTop: -iconHalfSize + (tip ? -20 : 0),
        marginLeft: -iconHalfSize
      }
    }, iconRestProps)),
    children: children ? children : style !== null && style !== void 0 && style.height || style !== null && style !== void 0 && style.minHeight ? /*#__PURE__*/_jsx("div", {
      style: style
    }) : undefined,
    style: style,
    tip: tip
  }, props));
}
export function TTable(_ref24) {
  var className = _ref24.className,
    _ref24$loading = _ref24.loading,
    loading = _ref24$loading === void 0 ? false : _ref24$loading,
    props = _objectWithoutProperties(_ref24, _excluded24);
  return /*#__PURE__*/_jsx(Table, _objectSpread({
    className: csn("t-table", className, cs.tTable),
    loading: loading === true ? {
      indicator: /*#__PURE__*/_jsx(TLoading, {})
    } : loading
  }, props));
}

// TODO: 完善该组件其他样式功能
export function TTypography(_ref25) {
  var className = _ref25.className,
    p = _objectWithoutProperties(_ref25, _excluded25);
  return /*#__PURE__*/_jsx(Typography, _objectSpread({
    className: csn("t-typography", className)
  }, p));
}
TTypography.TText = function (_ref26) {
  var className = _ref26.className,
    p = _objectWithoutProperties(_ref26, _excluded26);
  return /*#__PURE__*/_jsx(Typography.Text, _objectSpread({
    className: csn("t-typography-text", className)
  }, p));
};
TTypography.TTitle = Typography.Title;
TTypography.TParagraph = Typography.Paragraph;
export function TRadio(_ref27) {
  var className = _ref27.className,
    props = _objectWithoutProperties(_ref27, _excluded27);
  return /*#__PURE__*/_jsx(Radio, _objectSpread({
    className: csn("t-radio", className, cs.tRadio)
  }, props));
}
TRadio.Button = Radio.Button;
TRadio.Group = function (_ref28) {
  var className = _ref28.className,
    _ref28$type = _ref28.type,
    type = _ref28$type === void 0 ? "separate" : _ref28$type,
    props = _objectWithoutProperties(_ref28, _excluded28);
  return /*#__PURE__*/_jsx(Radio.Group, _objectSpread({
    className: csn("t-radio-group", className, cs.tRadioGroup, cs["tRadioGroup_".concat(type)])
  }, props));
};
export function TCheckbox(_ref29) {
  var className = _ref29.className,
    props = _objectWithoutProperties(_ref29, _excluded29);
  return /*#__PURE__*/_jsx(Checkbox, _objectSpread({
    className: csn("t-checkbox", className)
  }, props));
}
TCheckbox.Group = Checkbox.Group;
TCheckbox.TGroup = function (_ref30) {
  var className = _ref30.className,
    error = _ref30.error,
    props = _objectWithoutProperties(_ref30, _excluded30);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Checkbox.Group, _objectSpread({
      className: csn("t-checkbox-group", className)
    }, props)), error && /*#__PURE__*/_jsx(Typography.Text, {
      type: "danger",
      style: {
        fontWeight: "bold"
      },
      children: error
    })]
  });
};
function PlaceholderWrapper(props) {
  var _props$inputType = props.inputType,
    inputType = _props$inputType === void 0 ? "input" : _props$inputType,
    value = props.value,
    wrapperClassName = props.wrapperClassName,
    className = props.className,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onChange = props.onChange,
    placeholder = props.placeholder,
    error = props.error,
    resetProps = _objectWithoutProperties(props, _excluded31);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  function _onFocus(e) {
    setFocused(true);
    onFocus && onFocus(e);
  }
  function _onBlur(e) {
    setFocused(false);
    onBlur && onBlur(e);
  }
  var innerValue = useRef(value);
  useEffect(function () {
    innerValue.current = value;
  }, [value]);
  function _onChange(e) {
    innerValue.current = e.target.value;
    onChange === null || onChange === void 0 || onChange(e);
  }
  var hasOutValue = props.hasOwnProperty("value");
  /**
   * show up rules:
   * - has value and error;
   * - has value and placeholder;
   * - focused;
   */
  var showPlaceholderUp = useMemo(function () {
    var hasValue = !!value;
    if (!hasOutValue) {
      // 非受控组件的情况
      hasValue = !!innerValue.current;
    }
    return focused || hasValue && !!error || hasValue && placeholder;
  }, [value, hasOutValue, focused, error, placeholder]);
  return /*#__PURE__*/_jsxs("div", {
    className: csn("t-input-wrapper", wrapperClassName, error ? "t-input-wrapper-has-error" : undefined),
    children: [inputType === "textarea" ? /*#__PURE__*/_jsx(Input.TextArea, _objectSpread({
      value: value,
      onFocus: _onFocus,
      onBlur: _onBlur,
      onChange: _onChange,
      className: csn("t-input-textarea", className)
    }, resetProps)) : /*#__PURE__*/_jsx(Input, _objectSpread({
      value: value,
      onFocus: _onFocus,
      onBlur: _onBlur,
      onChange: _onChange,
      className: csn("t-input", className)
    }, resetProps)), /*#__PURE__*/_jsx("div", {
      className: csn("t-input-wrapper-placeholder", showPlaceholderUp && "t-input-wrapper-placeholder-up"),
      children: /*#__PURE__*/_jsx("span", {
        children: error || placeholder
      })
    })]
  });
}
export function TInput(props) {
  return /*#__PURE__*/_jsx(PlaceholderWrapper, _objectSpread({
    inputType: "input"
  }, props));
}
TInput.TextArea = function (props) {
  return /*#__PURE__*/_jsx(PlaceholderWrapper, _objectSpread({
    inputType: "textarea"
  }, props));
};
export function TInputNumber(props) {
  return /*#__PURE__*/_jsx(PlaceholderWrapper, _objectSpread({
    inputType: "InputNumber"
  }, props));
}
var TPassword = function TPassword(_ref31) {
  var className = _ref31.className,
    resetProps = _objectWithoutProperties(_ref31, _excluded32);
  var _useToggle5 = useToggle(),
    _useToggle6 = _slicedToArray(_useToggle5, 2),
    showPwd = _useToggle6[0],
    toggleShowPwd = _useToggle6[1].toggle;
  return /*#__PURE__*/_jsxs("div", {
    className: csn("t-password", cs.tPassword, className),
    children: [/*#__PURE__*/_jsx(TInput, _objectSpread(_objectSpread({}, resetProps), {}, {
      type: showPwd ? undefined : "password"
    })), /*#__PURE__*/_jsx("div", {
      className: cs.showPwd,
      children: /*#__PURE__*/_jsx(Iconfont, {
        icon: showPwd ? "icon_input_visible" : "icon_input_invisible",
        onClick: toggleShowPwd
      })
    })]
  });
};
TInput.TPassword = TPassword;
export var CTX_FormItem = /*#__PURE__*/createContext({});

/**
 * 包装 Form表单
 * @param param0
 * @returns
 */
export function TForm(_ref32) {
  var className = _ref32.className,
    props = _objectWithoutProperties(_ref32, _excluded33);
  return /*#__PURE__*/_jsx(Form, _objectSpread({
    className: csn(className, "t-form")
  }, props));
}

/**
 * 该组件使用RenderProps形式，结合context，共享FormItem的配置给受包裹的输入组件。
 * 并且不会显示错误提示。
 * @param param0
 */
TForm.TItem = function (_ref33) {
  var _children = _ref33.children,
    className = _ref33.className,
    name = _ref33.name,
    validateStatus = _ref33.validateStatus,
    labelHidden = _ref33.labelHidden,
    formItemProps = _objectWithoutProperties(_ref33, _excluded34);
  return /*#__PURE__*/_jsx(Form.Item, {
    noStyle: true,
    shouldUpdate: true,
    children: function children(formInstance) {
      var getFieldError = formInstance.getFieldError;
      var extraProps = {};
      // 根据验证的输出错误类型，输出不同级别的错误字段，默认为 error 类型
      extraProps[validateStatus || "error"] = !!name && getFieldError(name)[0];
      // 非完备的节点判别，暂时仅处理函数节点
      return /*#__PURE__*/_jsx(Form.Item, _objectSpread(_objectSpread({
        name: name,
        className: csn("t-form-item", className, labelHidden && "t-form-item-label-hidden")
      }, formItemProps), {}, {
        children: /*#__PURE__*/isValidElement(_children) ? /*#__PURE__*/cloneElement(_children, extraProps) : _children
      }));
    }
  });
};
export var TTooltip = function TTooltip(props) {
  return /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({}, props), {}, {
    overlayClassName: csn(props.overlayClassName, "t-tooltip", cs.tTooltip),
    children: props.children
  }));
};
export var TProgress = function TProgress(_ref34) {
  var className = _ref34.className,
    resetProps = _objectWithoutProperties(_ref34, _excluded35);
  return /*#__PURE__*/_jsx(Progress, _objectSpread(_objectSpread({}, resetProps), {}, {
    status: "normal",
    className: csn(className, "t-progress", cs.tProgress)
  }));
};
var _menuGenerator = function _menuGenerator(menus, selectedKeys) {
  return menus.map(function (_ref35) {
    var key = _ref35.key,
      name = _ref35.name,
      icon = _ref35.icon,
      path = _ref35.path,
      subMenus = _ref35.subMenus,
      onClick = _ref35.onClick;
    var title = path ? /*#__PURE__*/_jsx(TReportLink, {
      to: path,
      icon: icon,
      children: name
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [icon && /*#__PURE__*/_jsx(Iconfont, {
        icon: icon
      }), name]
    });
    return subMenus !== null && subMenus !== void 0 && subMenus.length ? /*#__PURE__*/_jsx(TSubMenu, {
      title: title,
      className: "".concat(subMenus.find(function (menu) {
        return selectedKeys.includes(menu.key);
      }) ? "t-navigator-selected-sub" : ""),
      children: _menuGenerator(subMenus, selectedKeys)
    }, key) : /*#__PURE__*/_jsx(TMenuItem, {
      className: "t-navigator-item",
      onClick: onClick,
      children: title
    }, key);
  });
};
export var TPageTitle = function TPageTitle(_ref36) {
  var className = _ref36.className,
    props = _objectWithoutProperties(_ref36, _excluded36);
  return /*#__PURE__*/_jsx("div", _objectSpread({
    className: csn("t-page-title", className)
  }, props));
};
export var TNavigator = function TNavigator(_ref37) {
  var className = _ref37.className,
    menus = _ref37.menus,
    title = _ref37.title,
    _ref37$mode = _ref37.mode,
    mode = _ref37$mode === void 0 ? "inline" : _ref37$mode,
    props = _objectWithoutProperties(_ref37, _excluded37);
  var _props$selectedKeys = props.selectedKeys,
    selectedKeys = _props$selectedKeys === void 0 ? [] : _props$selectedKeys;
  return /*#__PURE__*/_jsxs("div", {
    className: csn(className, "t-navigator", cs.tNavigator),
    children: [title && /*#__PURE__*/_jsx(TPageTitle, {
      style: {
        paddingLeft: 20
      },
      children: title
    }), /*#__PURE__*/_jsx(TMenu, _objectSpread(_objectSpread({
      mode: mode
    }, props), {}, {
      children: _menuGenerator(menus, selectedKeys)
    }))]
  });
};
export function TSearchInput(_ref38) {
  var className = _ref38.className,
    props = _objectWithoutProperties(_ref38, _excluded38);
  return /*#__PURE__*/_jsx(Input, _objectSpread({
    className: csn("t-search-input", className),
    allowClear: true,
    prefix: /*#__PURE__*/_jsx(Iconfont, {
      icon: "icon_search"
    })
  }, props));
}

// export function TLayout({ className, transparent = true, ...props }: LayoutProps & { transparent?: boolean }) {
//     return <Layout className={csn("t-layout", transparent && "transparent", className)} {...props} />;
// }
//
// TLayout.TSider = ({ className, transparent = true, spaceLeft, spaceRight, style, ...props }: SiderProps & { transparent?: boolean; spaceLeft?: number; spaceRight?: number }) => {
//     return (
//         <Layout.Sider className={csn("t-sider", transparent && "transparent", className)} style={{ ...{ marginLeft: spaceLeft, marginRight: spaceRight }, ...style }} {...props} />
//     );
// };
// TLayout.TContent = ({ className, ...props }: SiderProps) => {
//     return <Layout.Content className={csn("t-content", className)} {...props} />;
// };

export var TSteps = function TSteps(_ref39) {
  var className = _ref39.className,
    children = _ref39.children,
    resetProps = _objectWithoutProperties(_ref39, _excluded39);
  return /*#__PURE__*/_jsx(Steps, _objectSpread(_objectSpread({}, resetProps), {}, {
    className: csn("t-steps", cs.tSteps, className),
    children: children
  }));
};
TSteps.Step = Steps.Step;

// export function TDateRangePicker({ className, dropdownClassName, ...otherProps }: RangePickerProps) {
//     return <DatePicker.RangePicker className={csn("t-date-range-picker", className)} dropdownClassName={csn("t-date-range-picker-dropdown", className)} {...otherProps} />;
// }

export function TPopover(_ref40) {
  var overlayClassName = _ref40.overlayClassName,
    props = _objectWithoutProperties(_ref40, _excluded40);
  return /*#__PURE__*/_jsx(Popover, _objectSpread({
    overlayClassName: csn("t-popover-overlay", overlayClassName)
  }, props));
}
export function TTag(_ref41) {
  var className = _ref41.className,
    props = _objectWithoutProperties(_ref41, _excluded41);
  return /*#__PURE__*/_jsx(Tag, _objectSpread({
    className: csn("t-tag", className)
  }, props));
}
export function TAlert(_ref42) {
  var className = _ref42.className,
    props = _objectWithoutProperties(_ref42, _excluded42);
  return /*#__PURE__*/_jsx(Alert, _objectSpread({
    className: csn("t-alert", className)
  }, props));
}

// // 面包屑导航
// export function TBreadcrumb({ className, ...props }: BreadcrumbProps & { children: ReactNode }) {
//     return <Breadcrumb className={csn("t-breadcrumb", className)} {...props} />;
// }
//
// // 劫持 href 的设置。原设置是a标签默认行为。
// TBreadcrumb.Item = ({ href, children, ...props }: BreadcrumbItemProps & { children: ReactNode }) => (
//     <Breadcrumb.Item {...props}>{href ? <TReportLink to={href}>{children}</TReportLink> : children}</Breadcrumb.Item>
// );
// TBreadcrumb.Separator = Breadcrumb.Separator;
//
// export const TDatePicker: React.FC<DatePickerProps & { error?: string }> = ({ className, placeholder, error, ...resetProps }) => {
//     return <DatePicker {...resetProps} className={csn(".t-date-picker", cs.tDatePicker, className)} placeholder={error ?? placeholder} />;
// };